<app-menu-toggle
  tooltip="Screenshot mode: phoenix will become fullscreen and the menu is suppressed"
  [active]="ssMode"
  icon="ss-mode"
  (click)="toggleSSMode()"
>
</app-menu-toggle>
